/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_SubheadlineInputs */

const en_landing_hero_subheadline = /** @type {(inputs: Landing_Hero_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth, payments, subscriptions, credits, RBAC, CMS, and i18n — all pre-wired. Just build your product on top.`)
};

const zh_landing_hero_subheadline = /** @type {(inputs: Landing_Hero_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认证、支付、订阅、积分、权限、内容管理和国际化 — 全部预置就绪，直接在上面构建你的产品。`)
};

/**
* | output |
* | --- |
* | "Auth, payments, subscriptions, credits, RBAC, CMS, and i18n — all pre-wired. Just build your product on top." |
*
* @param {Landing_Hero_SubheadlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_hero_subheadline = /** @type {((inputs?: Landing_Hero_SubheadlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_SubheadlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_subheadline(inputs)
	return zh_landing_hero_subheadline(inputs)
});
export { landing_hero_subheadline as "landing.hero.subheadline" }